enum SortEnum {
  id          = 'id',
  refreshedAt = 'refreshedAt',
  price_low   = 'price_low',
  price_high  = 'price_high'
}

export default SortEnum;
